const PAY_OFF_STATUSES: readonly string[] = ['active', 'on_hold'];

export const isPayOffAllowed = (status: string | undefined): boolean =>
    status !== undefined && PAY_OFF_STATUSES.includes(status);
